module.exports = __webpack_public_path__ + "img/boy.d3fc9540.png";